import { DocumentService } from "./document.service";
import { Injectable } from "@angular/core";
import { AuthenticateService } from "./authenticate.service";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";
import { ProfissionalService } from "./profissional.service";
import { ToastController } from "@ionic/angular";
import { RAC } from "../models/avaliacaoRac/rac";
import { environment } from "../environments/environment";
import { HOST_EHR } from "../util/constants";
import { AtestadoRAC } from "src/models/avaliacaoRac/atestado";

@Injectable({
  providedIn: "root",
})
export class AvaliacaoRacService {
  constructor(
    private http: HttpClient,
    private auth: AuthenticateService,
    private documentService: DocumentService,
    private profissionalService: ProfissionalService,
    private toastController: ToastController
  ) { }

  async getList(): Promise<Array<RAC>> {
    let jwtDecode: any = await this.auth.getDecodeToken();
    let datas = [];
    let document: any = await this.getRead(
      `Composition?subject=Patient/${jwtDecode.cnsPaciente}&_include=Composition:subject&_sort=-date`
    );
    datas = document.entry.map(async (element) => {
      if (
        element.resource.meta.profile[0].includes(
          "BRRegistroAtendimentoClinico"
        )
      ) {
        let data = await this.get(element.fullUrl);
        return data;
      }
      return false;
    });
    datas = await Promise.all(datas);
    console.log(datas);
    return datas.filter((e) => e);
  }

  async get(fullUrl: string) {
    let document: any = await this.getReadFull(`${fullUrl}/$document?`);
    var datas = [];

    let result: RAC = {
      idRNDS: null,
      nuCNSCidadao: null,
      coCnes: null,
      timestampAtendimento: 0,
      dtAtendimento: null,
      nuCNSProfissional: null,
      coCboProfissional: null,
      nmEstabelecimento: null,
      coINE: null,
      nmProfissional: null,
      nmConselhoProfissional: "(Nº/UF)",
      nmCBOProfissional: null,
      codeAtendimento: null,
      tpAtendimento: null,
      caraterAtendimento: null,
      meioEntrada: null,
      motivoAtendimento: null,
      diagnostico: null,
      observacao: null,
      coCid: null,
      status: null,
      procedimentos: [],
      prescricoes: [],
      fullUrl: fullUrl,
      atestados: [],
    };
    if (document && document.entry) {
      if (document.entry) {
        await Promise.all(
          document.entry.map(async (element) => {
            if (
              element.resource.resourceType == "CarePlan" &&
              element.resource.meta.profile[0].includes("BRAtestado")
            ) {
              const atestado: AtestadoRAC = {
                id: null,
                idExport: element.resource.id,
                fullUrl: null,
                dtInicioAfastamento: "-",
                tempoAfastamento: "-",
                diagnostico: [],
              };
              if (element.resource.activity[0].detail.scheduledTiming.event[0])
                atestado.dtInicioAfastamento = moment(
                  element.resource.activity[0].detail.scheduledTiming.event[0]
                ).format("DD/MM/YYYY");
              if (
                element.resource.activity[0].detail.scheduledTiming.repeat.count
              )
                atestado.tempoAfastamento =
                  element.resource.activity[0].detail.scheduledTiming.repeat.count;
              if (element.resource.addresses && element.resource.addresses.length > 0) {
                for (const { index, value } of element.resource.addresses.map(
                  (value, index) => ({ value, index })
                )) {
                  await Promise.all(
                    document.entry.map(async (el) => {
                      if (el.fullUrl.includes(value.reference)) {
                        atestado.id = value.reference.split("/")[1];
                        atestado.fullUrl = el.fullUrl;
                        const code = await this.getCodeSystem(
                          el.resource.code.coding,
                          "BRCID10"
                        );
                        const dtDiagnostico = el.resource.onsetDateTime
                          ? moment(el.resource.onsetDateTime).format("DD/MM/YYYY")
                          : "-";
                        atestado.diagnostico.push({
                          CID10: code.code,
                          nmCID10: code.display,
                          dtDiagnostico,
                        });
                      }
                    })
                  );
                }
              } else {
                atestado.diagnostico.push({
                  CID10: '-',
                  nmCID10: '-',
                  dtDiagnostico: '-',
                });
              }
              result.atestados.push(atestado);
            }
            if (
              element.resource.resourceType == "Composition" &&
              element.resource.meta.profile[0].includes(
                "BRRegistroAtendimentoClinico"
              )
            ) {
              result.idRNDS = element.resource.id;
              result.nuCNSCidadao = element.resource.subject.identifier.value;

              await this.getCodeSystem([
                {
                  system: "http://hl7.org/fhir/composition-status",
                  code: element.resource.status,
                },
              ])
                .then((value) => {
                  result.status = value.display;
                })
                .catch((e) => {
                  result.status = "-";
                });

              if (
                element.resource.author &&
                element.resource.author.length > 0
              ) {
                await Promise.all(
                  element.resource.author.map(async (author) => {
                    if (
                      author.identifier.system.includes(
                        "BREstabelecimentoSaude"
                      )
                    ) {
                      result.coCnes = author.identifier.value;

                      const estabelecimento: any =
                        await this.getOrganizationInfo(result.coCnes);
                      result.nmEstabelecimento = estabelecimento.name;
                    }
                  })
                );
              }

              if (element.resource.section && element.resource.section.length) {
                const obs = element.resource.section.forEach((elSection) => {
                  if (elSection.entry && elSection.entry.length) {
                    const elEntry = elSection.entry[0].reference;

                    document.entry.forEach((el) => {
                      if (
                        (el.resource.meta.profile[0].includes(
                          "BRObservacaoDescritiva"
                        ),
                          elEntry.includes(el.resource.id))
                      ) {
                        console.log("ai sim2");
                        result.observacao = el.resource.valueString;
                      }
                    });
                  }
                });
              }
            }
            if (
              element.resource.meta.profile[0].includes("BRContatoAssistencial")
            ) {
              result.dtAtendimento = moment(
                element.resource.period.start
              ).format("DD/MM/YYYY");
              result.timestampAtendimento = moment(
                element.resource.period.start
              ).valueOf();

              await Promise.all(
                element.resource.participant.map(async (participant) => {
                  if (this.participanteResponsavel(participant)) {
                    result.nmConselhoProfissional = "-";
                    if (
                      participant.individual.identifier.system.includes(
                        "BRLotacaoProfissional"
                      )
                    ) {
                      const arCNS_CNES =
                        participant.individual.identifier.value.split("-");
                      result.nuCNSProfissional = arCNS_CNES[0];
                      let proff: any = await this.documentService.getReadFull(
                        HOST_EHR + "/api/fhir/r4/Practitioner/" + arCNS_CNES[0]
                      );
                      result.nmProfissional = proff.name[0].text;
                      try {
                        let prof: any =
                          await this.profissionalService.recuperarTodosPorCnsCpf(
                            result.nuCNSProfissional
                          );
                        if (prof.nuCrm) {
                          result.nmConselhoProfissional = `CRM-${prof.ufCrm} ${prof.nuCrm} `;
                        } else {
                          console.log(
                            "Erro ao buscar conselho do profissional"
                          );
                          // const toast = await this.toastController.create({
                          //     cssClass: 'modal-toast',
                          //     message: 'Ocorreu um erro ao recuperar o conselho do profissional.',
                          //     position: 'top',
                          //     duration: 2000
                          // });
                          // await toast.present();
                        }
                      } catch (err) {
                        console.error("===prof crm===", err);
                      }
                    }

                    await Promise.all(
                      participant.extension.map(async (ext) => {
                        if (ext.url.includes("BROcupacao")) {
                          await this.getCodeSystem(
                            ext.valueCodeableConcept.coding,
                            "BRCBO"
                          ).then((coding) => {
                            result.coCboProfissional = coding.code;
                            result.nmCBOProfissional = coding.display;
                          });
                        }
                        if (ext.url.includes("BRIdentificacaoEquipe")) {
                          result.coINE = ext.valueInteger;
                        }
                      })
                    );
                  }
                })
              );
              await this.getCodeSystem(
                [element.resource.class],
                "BRModalidadeAssistencial"
              ).then((coding) => {
                result.codeAtendimento = coding.code;
                result.tpAtendimento = coding.display;
              });

              await this.getCodeSystem(
                element.resource.priority.coding,
                "BRCaraterAtendimento"
              ).then((coding) => {
                result.caraterAtendimento = coding.display;
              });
              await this.getCodeSystem(
                element.resource.hospitalization.admitSource.coding,
                "BRProcedencia"
              ).then((coding) => {
                result.meioEntrada = coding.display;
              });

              if (
                element.resource.reasonReference &&
                element.resource.reasonReference.length
              ) {
                const obs = element.resource.reasonReference[0].reference;
                document.entry.forEach((el) => {
                  if (
                    (el.resource.meta.profile[0].includes(
                      "BRObservacaoDescritiva"
                    ),
                      obs.includes(el.resource.id))
                  ) {
                    result.motivoAtendimento = el.resource.valueString;
                  }
                });
              }
            }

            if (
              element.resource.meta.profile[0].includes(
                "BRObservacaoDescritiva"
              )
            ) {
              result.observacao = element.resource.valueString;
            }

            if (element.resource.meta.profile[0].includes("BRCID10Avaliado")) {
              await this.getCodeSystem(
                element.resource.code.coding,
                "BRCID10"
              ).then((coding) => {
                result.coCid = coding.code;
                result.diagnostico = coding.display;
              });
            }
            if (element.resource.meta.profile[0].includes("BRCIAP2Avaliado")) {
              result.motivoAtendimento = element.resource.note[0].text;
            }
            if (
              element.resource.meta.profile[0].includes("BRProblemaDiagnostico")
            ) {
              element.resource.code.coding.forEach(async (code) => {
                if (code.system.includes("BRCIAP2")) {
                  await this.getCodeSystem(
                    element.resource.code.coding,
                    "BRCIAP2"
                  ).then((coding) => {
                    result.diagnostico = coding.display;
                  });
                }
                if (code.system.includes("BRCID10")) {
                  await this.getCodeSystem(
                    element.resource.code.coding,
                    "BRCID10"
                  ).then((coding) => {
                    result.diagnostico = coding.display;
                  });
                }
              });
            }
            if (
              element.resource.meta.profile[0].includes(
                "BRProcedimentoRealizado"
              )
            ) {
              const nome = new Promise<string>((resolve) => {
                this.getCodeSystem(element.resource.code.coding)
                  .then((value) => {
                    resolve(value.code + "-" + value.display);
                  })
                  .catch((e) => {
                    resolve("-");
                  });
              });

              const status = new Promise<string>((resolve) => {
                this.getCodeSystem([
                  {
                    system: "http://hl7.org/fhir/event-status",
                    code: element.resource.status,
                  },
                ])
                  .then((value) => {
                    resolve(value.display);
                  })
                  .catch((e) => {
                    resolve("-");
                  });
              });

              await Promise.all([nome, status]).then((values) => {
                result.procedimentos.push({
                  nome: values[0],
                  status: values[1],
                });
              });
            }
            if (
              element.resource.meta.profile[0].includes(
                "BRPrescricaoMedicamento"
              )
            ) {
              const medicamento = new Promise<string>((resolve) => {
                const med = document.entry.find((el) =>
                  el.fullUrl.includes(
                    element.resource.medicationReference.reference
                  )
                );

                if (med) {
                  this.getCodeSystem(med.resource.code.coding)
                    .then((value) => {
                      resolve(value.display);
                    })
                    .catch((e) => {
                      resolve("-");
                    });
                }
              });

              if (
                element.resource.dosageInstruction &&
                element.resource.dosageInstruction.length
              ) {
                await Promise.all(
                  element.resource.dosageInstruction.map(async (dI) => {
                    const tipo = new Promise<string>((resolve) => {
                      if (dI.doseAndRate && dI.doseAndRate.length) {
                        dI.doseAndRate.forEach((dR) => {
                          this.getCodeSystem(dR.type.coding, "BRUnidadeMedida")
                            .then((value) => {
                              resolve(value.display);
                            })
                            .catch((e) => {
                              resolve("-");
                            });
                        });
                      } else {
                        resolve("-");
                      }
                    });

                    const via = new Promise<string>((resolve) => {
                      if (dI.route) {
                        this.getCodeSystem(
                          dI.route.coding,
                          "BRViaAdministracao"
                        )
                          .then((value) => {
                            resolve(value.display);
                          })
                          .catch((e) => {
                            resolve("-");
                          });
                      } else {
                        resolve("-");
                      }
                    });

                    await Promise.all([tipo, medicamento, via]).then(
                      (values) => {
                        result.prescricoes.push({
                          nmMedicamento: values[1],
                          tpMedicamento: values[0],
                          tpVia: values[2],
                        });
                      }
                    );
                  })
                );
              } else {
                await medicamento.then((medicamento) => {
                  result.prescricoes.push({
                    nmMedicamento: medicamento,
                    tpMedicamento: "-",
                    tpVia: "-",
                  });
                });
              }
            }
          })
        );
      }
    }
    return result;
  }

  async getRead(reference) {
    return this.http
      .get(HOST_EHR + "/api/fhir/r4/" + reference, {
        headers: await this.getHeadersContextText(),
      })
      .toPromise()
      .then((data) => {
        return data;
      })
      .catch(async (error) => {
        console.error(error);
        if (
          error.error &&
          error.error.resourceType == "OperationOutcome" &&
          !environment.production
        ) {
          const toast = await this.toastController.create({
            message: error.error.issue[0].diagnostics,
            position: "top",
            duration: 4000,
            cssClass: "toast-error",
          });
          toast.present();
        }

        throw new Error(JSON.stringify(error));
      });
  }

  participanteResponsavel(participante) {
    let responsavel = false;
    participante.type.forEach((type) => {
      type.coding.forEach((coding) => {
        if (
          coding.system.includes("BRResponsabilidadeParticipante") &&
          coding.code == "atendimento"
        ) {
          responsavel = true;
        }
      });
    });
    return responsavel;
  }

  async getCodeSystem(coding, keySystem = null) {
    let valor: {
      code: string;
      display: string;
    } = { code: null, display: null };
    let busca;
    if (keySystem) {
      coding.forEach((cod) => {
        if (cod.system.includes(keySystem)) {
          busca = cod;
        }
      });
    } else {
      busca = coding[0];
    }
    valor.code = busca.code;
    const cable: any = await this.documentService.getReadSystem(busca);
    valor.display = "-";
    if (cable && cable.parameter) {
      valor.display = cable.parameter.find(
        (data) => data.name == "display"
      ).valueString;
    }
    return valor;
  }

  async getOrganizationInfo(cnes) {
    return this.http
      .get(HOST_EHR + "/api/fhir/r4/Organization/" + cnes, {
        headers: await this.getHeadersContextText(),
      })
      .toPromise()
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return [];
      });
  }

  getHeadersContextText() {
    let server = JSON.parse(localStorage.getItem("app_icp_token"));
    const httpOptions = {
      "Content-Type": "application/json",
      //'X-Authorization-Origin': ORIGIN,
      //'X-Authorization-Audience': 'prosus.saude.gov.br',
      //'X-Authorization-Server': 'CN=RNDS:PROSUS,CN=AC-RESTRITA-RNDS,O=DATASUS,C=BR',
      "X-Authorization-Server": "Bearer " + server.access_token,
      Authorization: "Bearer " + this.auth.getAuthorizationToken(),
    };

    return httpOptions;
  }

  async getReadFull(reference) {
    return this.http
      .get(reference, { headers: await this.getHeadersContextText() })
      .toPromise()
      .then((data) => {
        return data;
      })
      .catch(async (error) => {
        console.error(error);
        if (
          error.error &&
          error.error.resourceType == "OperationOutcome" &&
          !environment.production
        ) {
          const toast = await this.toastController.create({
            message: error.error.issue[0].diagnostics,
            position: "top",
            duration: 4000,
            cssClass: "toast-error",
          });
          toast.present();
        }

        throw new Error(JSON.stringify(error));
      });
  }
}
